import { render } from "./postage.vue?vue&type=template&id=7af3826f&ts=true"
import script from "./postage.vue?vue&type=script&lang=ts"
export * from "./postage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__